/**
 * Meta Pixel — tracciamento conversioni per la campagna Instagram/Facebook.
 * Si attiva SOLO se:
 *  1. REACT_APP_META_PIXEL_ID è configurato (Teresa fornisce il Pixel ID), e
 *  2. il visitatore ha accettato i cookie (banner consenso del sito).
 * Senza queste due condizioni non viene caricato nessuno script.
 */

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = "tv_cookie_consent_v1";

export function hasConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
}

export function initMetaPixel() {
  if (!PIXEL_ID || !hasConsent() || window.fbq) return false;
  const n = (window.fbq = function () {
    n.queue.push(arguments);
  });
  n.queue = [];
  n.loaded = true;
  n.version = "2.0";
  const t = document.createElement("script");
  t.async = true;
  t.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(t);
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
  return true;
}

/** Evento "Contact" al click su un pulsante WhatsApp (conversione della campagna). */
export function trackWhatsAppContact(contentName) {
  if (!window.fbq) initMetaPixel(); // inizializza se nel frattempo ha accettato i cookie
  if (window.fbq) window.fbq("track", "Contact", { content_name: contentName });
}

export const META_PIXEL_READY = !!PIXEL_ID;
